import React from 'react';
import { PrizesTable } from '../PrizesTable';
import { RankPrizesTable } from '../RankPrizesTable';
import { usePortletTranslations } from '../../../../system/Portlet/hooks';

export const Prizes = ({ showRankPrizes, showPointsPrizes, showEventPrizes,
                           pointBasedPrizes, eventBasedPrizes, prizes, scrollTo, useRounds }) => {
    const t = usePortletTranslations();
    return (
        <div>
            {showRankPrizes && <RankPrizesTable data={prizes} scrollTo = {scrollTo} />}
            {showPointsPrizes && <PrizesTable tableTitle={t('pointprizes')}
                         tableRightName={t('competitorsTable.head.prize')}
                         tableLeftName={t('points')}
                         data={pointBasedPrizes}/>}
            {showEventPrizes && <PrizesTable tableTitle={useRounds ? t('roundsprizes') : t('prizes.eventPrizes')}
                         tableRightName={t('competitorsTable.head.prize')}
                         tableLeftName={useRounds ? t('roundsplayed') : t('prizes.eventsPlayed')}
                         data={eventBasedPrizes}/>}
        </div>);
};

